<template>
  <v-container>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title
            id="tableTitle"
            class="primary--text"
            style="font-size: 1.5em; padding: 20px"
          >{{ $t("nav.errorLog") }}</v-card-title>
          <v-data-table :headers="headers" :items="items" :items-per-page="20" class="elevation-0" :search="search" :custom-filter="filterOnlyCapsText">
            <template v-slot:top>
              <v-text-field v-model="search" :label="$t('common.search')" class="mx-4"></v-text-field>
            </template>
            <template slot="item" slot-scope="props">
              <tr>
                <td style="text-align: left">{{ props.item.source }}</td>

                <td style="text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width: 1px">{{ props.item.message }}</td>
                <td
                  style="text-align: center"
                >{{ longDateMixinFmt(props.item.created) || props.item.created }}</td>
                <td style="text-align: center">
                  <v-btn
                    class="mr-1"
                    color="primary"
                    x-small
                    fab
                    outlined
                    elevation="1"
                    @click="deleteItem(props.item)"
                  >
                    <v-icon small color="primary">mdi-delete</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    x-small
                    fab
                    outlined
                    elevation="1"
                    @click="showMore(props.item)"
                  >
                    <v-icon small color="primary">visibility</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="dialog" persistent width="500">
            <v-card>
              <v-card-title class="headline">{{$t("errorlog.message")}}</v-card-title>
              <v-spacer></v-spacer>
              <v-card-text>{{this.editedItem ? this.editedItem.message : null}}</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="close()">{{$t("common.ok")}}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from "vuex";

  export default {
    data() {
      return {
        dialog: false,
        editedItem: null,
        search: "",
        headers: [
          {
            text: this.$t("errorlog.source"),
            align: "left",
            value: "source",
          },
          {
            text: this.$t("errorlog.message"),
            align: "left",
            value: "message",
            width: "40%",
          },
          {
            text: this.$t("errorlog.createDate"),
            align: "center",
            sortable: true,
            value: "created",
          },
          {
            text: this.$t("column.actions"),
            align: "center",
            value: "actions",
            sortable: false,
          },
        ],
      };
    },
    computed: {
      ...mapGetters(["m_errorLog/getErrors"]),
      items() {
        return this["m_errorLog/getErrors"];
      },
    },
    methods: {
      ...mapMutations(["mHideLongLoader"]),
      ...mapActions([
        "m_errorLog/fetchErrors",
        "m_errorLog/updateError",
        "m_errorLog/deleteError",
      ]),
      refreshErrors() {
        this["m_errorLog/fetchErrors"]();
        this.editedItem = null;
      },
      showMore(item) {
        this.editedItem = Object.assign({}, item);
        this.editedItem.silentUpdate = true;
        this.dialog = true;
      },
      close() {
        this["m_errorLog/updateError"](this.editedItem).then(this.refreshErrors);
        this.dialog = false;
      },
      deleteItem(item) {
        this.$confirm(
          this.$t("warning.delete") +
            this.$t("errorlog.error").toLowerCase() +
            "?",
          {
            buttonTrueText: this.$t("common.ok"),
            buttonFalseText: this.$t("common.cancel"),
            color: "warning",
            icon: "warning",
            title: this.$t("common.warning"),
            width: 350,
            property: "$confirm",
          }
        ).then(
          (res) =>
            res && this["m_errorLog/deleteError"](item).then(this.refreshErrors)
        );
      },
    },
    filterOnlyCapsText(value, search) {
      return value != null && search != null && typeof value === "string" && value.toString().indexOf(search) !== -1;
    },
    created() {
      this.refreshErrors();
    },

    mounted() {
      this.refreshErrors();
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.mHideLongLoader();
      });
    },
  };
</script>
<style  scoped>
  .container {
    max-width: 90%;
  }
</style>
